module.exports = __webpack_public_path__ + "img/bn0710.61a9f57e.png";